import { render, staticRenderFns } from "./DeliveryOpenAddress.vue?vue&type=template&id=34dbaf28"
import script from "./DeliveryOpenAddress.vue?vue&type=script&lang=ts"
export * from "./DeliveryOpenAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports